import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';

import {
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
  setRemoveSuperBatchesModalStage,
} from 'features/classCreation';
import RemoveSuperBatchesToggleChips from '../RemoveSuperBatchesToggleChips';
import SectionHeading from 'components/SectionHeading';
import styles from './BulkRemoveSuperBatchesModalSelectStage.module.scss';

export default function BulkRemoveSuperBatchesModalSelectStage({
  selectedSuperBatches,
  setSelectedSuperBatches,
}) {
  const dispatch = useDispatch();
  const isButtonDisabled = selectedSuperBatches.length === 0;

  const handleBackClick = useCallback(() => {
    dispatch(
      setRemoveSuperBatchesModalStage(
        BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.info
      )
    );
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    dispatch(
      setRemoveSuperBatchesModalStage(
        BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.confirm
      )
    );
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className="m-b-xs h3">
        <Icon
          name="arrow-left"
          className="m-r-xxs cursor"
          onClick={handleBackClick}
        />
        back
      </div>
      <SectionHeading
        title={
          <>
            <Icon
              name="minus-circle"
              className="primary m-r-xxs"
            />
            Remove Batch/es
          </>
        }
        titleClassName={styles.heading}
        className={styles.sectionHeading}
      />
      <RemoveSuperBatchesToggleChips
        selectedSuperBatches={selectedSuperBatches}
        setSelectedSuperBatches={setSelectedSuperBatches}
      />
      <Tappable
        className="btn btn-primary"
        onClick={handleConfirm}
        disabled={isButtonDisabled}
      >
        Confirm
      </Tappable>
    </div>
  );
}
